import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Switch } from "@mui/material";
import { SHIFT_LOG_TASK_FIELDS } from "../../constants";

const ShiftLogTasksDisplay = ({ shift_log }) => {
  const [hideUncompletedTasks, setHideUncompletedTasks] = useState(true);
  return (
    <>
      <div className="log-rows">
        {SHIFT_LOG_TASK_FIELDS.map((log) => {
          if (hideUncompletedTasks && !shift_log[log.key]) return <></>;
          return (
            <>
              <span
                className={`log-rows__icon ${
                  shift_log[log.key]
                    ? "fa fa-check log-rows__icon__green"
                    : "fa fa-times log-rows__icon__red"
                }`}
              ></span>
              <b>{log.label}:</b>
              <div className="log-rows__text">{shift_log[log.textKey]}</div>
            </>
          );
        })}
      </div>
      <FormControlLabel
        control={
          <Switch
            onClick={() => setHideUncompletedTasks(!hideUncompletedTasks)}
            defaultChecked={hideUncompletedTasks}
          />
        }
        label="Show Uncompleted Tasks"
      />
    </>
  );
};
ShiftLogTasksDisplay.propTypes = {
  shift_log: PropTypes.object
};

export default ShiftLogTasksDisplay;
